export default class IssuesModalCtrl {
  constructor($routeParams, $uibModal, $filter, $q, IssuesTreeFactory, Issue,
    $timeout, Errors) {
    this.openModal = $uibModal.open;
    this.routeParams = $routeParams;
    this.errors = Errors;
    this.timeout = $timeout;

    // View stuff
    this.issuesTree = new IssuesTreeFactory();
    this.issuesTree.api.get();
    this.model = Issue;
    this.newScratch = new this.model();
    this.addChild = false;
    this.addButtonStates = {
      false: `Add ${$filter('lexicon')('issue')}`,
      true: 'Adding... <i class="font-icon-sm icon-spinner icon-spin">'
    }
    this.treeSettings = {
      dropped: () => {
        this.issuesTree.setData();
      }
    };
    this.focusIssueInput();
  }
  focusIssueInput() {
    // this.timeout(() => {
    //   angular.element('.top-issue-field input').focus();
    // }, 0, false);
  }
  focusSubissueInput() {
    // this.timeout(() => {
    //   angular.element('.sub-issue input').focus();
    // }, 0, false);
  }
  cancelReassign() {
    delete this.reassign;
  }

  showSubissueForm(parent) {
    parent.addChild = true;
    this.addChild = true;
    this.focusSubissueInput();
  }

  hideSubissueForm(parent) {
    parent.addChild = false;
    this.addChild = false;
    this.focusIssueInput();
  }

  updateIssueOrder() {
    return this.issuesTree.api.update({}, {
      legalIssues: this.issuesTree.data
    });
  }
  requestDelete(model) {
    // DELETE fails on first attempt with confirmation code
    // which is included in the second attempt
    return model.api.delete({
      reassign: this.reassign ? this.reassign.data.to.id : null
    }).then(() => {
      // Remove issue on successful delete request
      // track issue removed
      if (this.reassign) {
        model.data.children.forEach(node => {
          this.issuesTree.add(node, this.reassign.data.to);
        })
      }
      this.issuesTree.remove(model.data);
      delete this.reassign;

    }, response => {
      // Open a Modal to confirm the delete request, offer alternatives

      if (response.status === 412) {
        this.openModal({
          template: require('./confirm-delete.html'),
          windowTemplateUrl: '/modals/default/modal-container.html',
          controller: ['$scope', function (scope) {
            scope.hasFacts = response.data.explanationCode ===
              'factsAssociated';
            scope.hasChildren = model.data.children && model.data
              .children.length > 0;
          }]
        }).result.then(action => {
          if (action === 'delete') {
            this.requestDelete(model);
          } else {
            this.reassign = model;
          }
        }, () => {
          // cancel clears conf code, so next attempt prompts
          delete model.data.confirmationCode;
        });
      }
    })
  }
  deleteIssue(issue) {
    var issueModel = new this.model(issue);

    // First, update issue order before deleting, since
    // server is unaware of current hierarchy
    this.updateIssueOrder().then(() => {
      this.requestDelete(issueModel)
    }, () => {
      this.errors.data['delete-issue'] = {
        error: "Could not save issue order",
        details: "Please try updating the issue order before deleting your issue."
      };

    });
  }
  updateIssue(issue) {
    return new this.model(issue).api.update()
      .then(data => issue = Object.assign(issue, data))
  }
  createRootIssue(displayName) {
    return new this.model({ displayName }).api.create()
      .then(data => this.issuesTree.add(data))
  }
  createSubIssue(displayName, parent) {
    const parentId = parent.id;
    return new this.model({ displayName, parentId }).api.create()
      .then(data => this.issuesTree.add(data, parent))
  }

  /*createIssue(parent) {
    //  Unused legacy method for reference
    if (parent && parent.id) {
      this.newScratch.data.parentId = parent.id;
    }

    this.updateIssueOrder().then(() => {
      this.newScratch.api.create().then(() => {
        // Insert new issue into tree
        this.issuesTree.add(this.newScratch.data, parent);

        // Clear view settings
        if (parent) {
          this.hideSubissueForm(parent);
        }
        this.newScratch.data = {};

        this.updateIssueOrder();
      }, response => {
        this.validations = response.data.data;
      });
    }, () => {
      this.errors.data['add-issue'] = {
        error: "Could not save issue order",
        details: "Please try updating the issue order before adding your issue."
      };
    });
  }*/
}
IssuesModalCtrl.$inject = ['$routeParams', '$uibModal', '$filter', '$q',
  'IssuesTreeFactory', 'Issue', '$timeout', 'Errors'
];



// WEBPACK FOOTER //
// ./project/modals/issues/issues.controller.js